import { request } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getallcategorys: option =>
    request('v1/category/getallcategorys', option, true, false), // 获取所有分组
  addcategory: option =>
    request('v1/category/addcategory', option, true, false), // 增加分类
  updatecategory: option =>
    request('v1/category/updatecategory ', option, true, false), // 修改分类
  deletecategory: option => {
    const urls = querystring(option)
    return request('v1/category/deletecategory' + urls, {}, true, false) // 删除分类
  },
  getcategorytemplate: option => {
    const urls = querystring(option)
    return request('v1/category/getcategorytemplate' + urls, {}, true, false) // 根据第三级类别获取属性
  },
  updatecategorytemplate: option => {
    return request('v1/category/updatecategorytemplate', option, true, false) // 更新属性
  },
  getfieldh5displayexcludes: option => {
    return request('v1/category/getfieldh5displayexcludes', option, true, false) // 更新属性
  },
  setfieldh5displayexcludes: option => {
    return request('v1/category/setfieldh5displayexcludes', option, true, false) // 更新属性
  },
  getcategorys: option =>
    request('v1/category/getcategorys', option, true, false) // 获取所有分组
}
